<template>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      :width="width"
      :height="height"
      viewBox="0 0 640 512"
      :aria-labelledby="iconName"
      role="presentation"
    >
      <title :id="iconName" lang="en">{{ iconName }} icon</title>
      <g :fill="color">
        <slot>
          <component :is="iconName" />
        </slot>
      </g>
    </svg>
  </template>
  
  <script>
  export default {
    props: {
      iconName: {
        type: String,
        default: 'IconPlaceholder',
      },
      width: {
        type: [Number, String],
        default: 18,
      },
      height: {
        type: [Number, String],
        default: 18,
      },
      color: {
        type: String,
        default: null,
      },
    },
  };
  </script>
  
  <style scoped>
  svg {
    display: inline-block;
    vertical-align: baseline;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/Icon2.vue